import { DeleteFilled, LinkOutlined } from '@ant-design/icons';
import WayMapper from '../../Util/WayMapper';
import styles from './Way.module.css'
import { Button, Popconfirm } from 'antd';
const Way = ({title , type , links , onDelete})=>{
    return <div className={styles.Way}>
        <div className={styles.Main}>
        <div className={styles.Header}>{WayMapper[type].icon} {WayMapper[type].title}</div>
        {title}
        </div>
        {Array.isArray(links)  && <a rel="noreferrer" href={links[links.length - 1]} target='_blank'><Button type='text' size='small'  icon={<LinkOutlined />} /></a>}
        <Popconfirm onConfirm={onDelete} title="آیا از حذف این روش یادگیری مطمئنید؟">
            <Button icon={<DeleteFilled />} type='text' danger size='small' />
        </Popconfirm>
        </div>
}
export default Way;